/**
 * Get the current time in a given timezone.
 */
export function getNowInTz(timezone: string): Date {
  const now = new Date();
  const tzStr = now.toLocaleString('en-US', { timeZone: timezone });
  return new Date(tzStr);
}
